import Cookies from 'js-cookie';
import { up } from 'slide-element';
import { getElementParents, triggerEvent } from '../helpers/general';

document.querySelectorAll('.site-notification .close-alert').forEach((closeAlert) => {
  closeAlert.addEventListener('click', (e) => {
    e.preventDefault();
    const alert = getElementParents(e.currentTarget, '.alert')[0];

    up(alert);

    Cookies.set(
      alert.dataset.cookie,
      true,
      { expires: 1 },
    );
  });
});

document.querySelectorAll('.site-notification').forEach((siteNotification) => {
  if (!Cookies.get(siteNotification.dataset.cookie)) {
    siteNotification.classList.remove('no-display');
  }
});

document.querySelectorAll('.filter-form select').forEach((select) => {
  select.addEventListener('change', () => {
    const filterFormData = getElementParents(select, '.filter-form')[0].dataset;
    const autoSubmitEnabled = filterFormData.mobileAutosubmit === '';

    if (window.clientWidth > 992 || autoSubmitEnabled) {
      triggerEvent(getElementParents(select, 'form')[0], 'submit');
    }
  });
});

document.querySelectorAll('.toggle-filters').forEach((toggleFilter) => {
  toggleFilter.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('.card-filters').forEach((cardFilter) => {
      cardFilter.classList.toggle('active');
    });
  });
});
